module.exports = __webpack_public_path__ + "static/site-1783527333127/img/asset_newsletter-md-bg.abdfa59f.png";